import StaticListParamsHandler from "./StaticListParamsHandler";

const handler = StaticListParamsHandler(({params, translationManager}) => {
    return translationManager.translate(`$t(animalModList.remove) "{{eventType}} {{date}}"`, params);
});

handler.RegExp = new RegExp(`^2058$`, "g");

export default handler;